import React, { useEffect } from 'react';
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const RadioButton = ({ label, value, onChange ,checked}:any) => {
  
  return (
    <label className={tw`mr-6 cursor-pointer flex items-center`}>
      <input
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        className={tw`mr-2`}
        // className={tw`appearance-none h-4 w-4 border-2 border-gray-300 rounded-full 
        //   checked:bg-red-500 checked:border-red-500 focus:outline-none`}
      />
      <span className={tw`whitespace-nowrap`}>{label}</span>
      
    </label>
  );
};

export default RadioButton;
